const la_mas_pop = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_PRINCIPAL",
        "tarifa": {
            "id": "PPOSFIXEDLINEAVATEL1",
            "price": 24.786,
            "name": "Funk 1 GB",
            "operator": "AVATEL",
            "segment": "PARTICULAR",
            "category": "fixed_line",
            "color": "",
            "commercial_enrichment": "",
            "description_file": "",
            "fixed_line_info": {
                "type": "",
                "owners": [],
                "upload_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "download_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": 0
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "mobile_line_info": null,
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-11-24T18:12:00.516244+01:00",
            "updated_on": "2022-12-05T18:26:35.929362+01:00",
            "svas": [],
            "promotions": [
                "PROMOAVATEL",
                "PROMOAVATEL1"
            ],
            "additional_lines": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "WIFI_6AVATEL",
            "price": 4.1239,
            "name": "WiFi 6",
            "operator": "AVATEL",
            "image": "",
            "more_info": "",
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T17:55:20.164020+01:00",
            "updated_on": "2022-11-24T17:55:20.164048+01:00",
            "promotions": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "MAS_CLICTV_+_DAZN_TOTALAVATEL",
            "price": 24.7934,
            "name": "Más CLICtv + DAZN Total",
            "operator": "AVATEL",
            "image": "",
            "more_info": "",
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T18:34:43.381541+01:00",
            "updated_on": "2022-11-30T16:54:45.183738+01:00",
            "promotions": [
                "PROMOAVATEL5",
                "PROMOAVATEL3",
                "PROMOAVATEL4",
                "PROMOAVATEL7"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOAVATEL5",
                "duration": -1,
                "name": "Dazn Total & La más Pop",
                "duration_unit": "month",
                "amount": "10.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": null,
                "operator": "AVATEL"
            }
        ]
    }
]

export default la_mas_pop;